module.exports = __webpack_public_path__ + "static/logo-bb8e29c7e03a2b0c8671697152ce4ff4.svg";